module.exports = __webpack_public_path__ + "img/programme2.c52c32ee.png";